import * as React from "react";
import { Link } from "react-router-dom";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";

import { FileMetadataItem } from "./fileSlice";
import { ImageListItemBar } from "@mui/material";

let baseUrl: string;
switch (process.env.NODE_ENV) {
    case "development": {
        baseUrl = "/apidev";
        break;
    }
    case "test": {
        baseUrl = "/apidev";
        break;
    }
    case "production": {
        baseUrl = "/api";
        break;
    }
    default: {
        baseUrl = "/api";
        break;
    }
}

export default function MyImageList({
    data,
}: {
    data: { [key: string]: FileMetadataItem };
}) {
    const sorted = Object.values(data).sort((a, b) =>
        b.metadata.created.ts.localeCompare(a.metadata.created.ts),
    );
    return (
        <ImageList
            sx={{ width: { xs: "100%", md: 1000 }, height: 650 }}
            cols={3}
            rowHeight={300}
        >
            {sorted.map((item) => {
                let srcSet =
                    baseUrl +
                    `/file/download/${item.metadata.id}.${item.extension}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`;
                let src =
                    baseUrl +
                    `/file/thumbnail/${item.metadata.id}.${item.extension}?w=164&h=164&fit=crop&auto=format`;
                console.log(item, srcSet, src);
                return (
                    <ImageListItem key={item.metadata.id}>
                        <img
                            srcSet={srcSet}
                            src={src}
                            alt={item.name}
                            loading="lazy"
                        />
                        <ImageListItemBar
                            title={item.metadata.created.ts}
                            actionIcon={
                                <IconButton
                                    component={Link}
                                    to={"/file/view/" + item.metadata.id}
                                    sx={{ color: "rgba(255, 255, 255, 0.54)" }}
                                    aria-label={`info about ${item.name}`}
                                >
                                    <InfoIcon />
                                </IconButton>
                            }
                        />
                    </ImageListItem>
                );
            })}
        </ImageList>
    );
}
